import { Component, ElementRef, HostListener, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Location, CommonModule } from '@angular/common';
import { Dialog } from '@angular/cdk/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons';
import { SHARED_COMPONENTS } from '../shared';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, ...SHARED_COMPONENTS],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  baseUrl: string;
  faLogout = faPowerOff;
  faUser = faUser;
  menuOpen = signal<boolean>(false);

  produccion = environment.production;
  accentTextClass = this.produccion
    ? 'text-sky-600 dark:text-sky-500'
    : 'text-rose-600 dark:text-rose-400';
  accentButtonClass = this.produccion
    ? 'bg-sky-600 hover:bg-sky-700'
    : 'bg-rose-600 hover:bg-rose-700';
  accentHeaderGradientClass = this.produccion
    ? 'bg-gradient-to-br from-sky-500 to-sky-700'
    : 'bg-gradient-to-br from-rose-500 to-rose-700';
  accentSubtleClass = this.produccion ? 'text-sky-100' : 'text-rose-100';
  accentSubtleMutedClass = this.produccion ? 'text-sky-100/80' : 'text-rose-100/80';

  private authService = inject(AuthService);
  private host = inject(ElementRef<HTMLElement>);

  constructor(
    private router: Router,
    private location: Location,
    private dialog: Dialog
  ){
    this.baseUrl = this.location.prepareExternalUrl('/')
  }

  get session() {
    return this.authService.getSession();
  }

  get userRoleLabel(): string | null {
    const name = (this.session?.nombres ?? '').toUpperCase();
    if (name.startsWith('DESARROLLADOR')) return 'Desarrollador';
    if (name.startsWith('SOPORTE')) return 'Soporte';
    return null;
  }

  toggleMenu(): void {
    this.menuOpen.update((v) => !v);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  toRedirec(path: string){
    const redirectUrl = `${this.baseUrl}/${path}`;
    this.router.navigateByUrl(redirectUrl);
  }

  logout(): void {
    this.closeMenu();
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.menuOpen()) return;
    const target = event.target as Node;
    if (!this.host.nativeElement.contains(target)) {
      this.closeMenu();
    }
  }
}
